"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_URL_TOKEN_HEADER = exports.BOARD_CONTEXT_HEADER = void 0;
exports.BOARD_CONTEXT_HEADER = 'x-air-board-context';
exports.SHORT_URL_TOKEN_HEADER = 'x-air-short-url-token';
//# sourceMappingURL=auth.js.map